import { Grid, Paper, makeStyles } from '@material-ui/core'
import React from 'react'
import { CardVacunas } from './Enfermeria/CardVacunas';
import clsx from 'clsx';
import { CardSignosVitales } from './ResumenHCE/CardSignosVitales';

const useStyles = makeStyles((theme) => {
  return {
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },
    content: {
      flexGrow: 1,
      marginTop: 25,
    },
    fixedHeight: {
      height: 500,
    },
    icon: {
      marginRight: theme.spacing(2),
    },
    heroContent: {
      padding: theme.spacing(0, 0, 0),
      marginTop: '50px',
    },
    heroButtons: {
      marginTop: theme.spacing(4),
    },
    footer: {
      padding: theme.spacing(3),
      marginTop: 'auto',
      display: 'flex',
      flexDirection: 'column',
    },
  };
});

export const TabEnfermeria = (props) => {
  const classes = useStyles();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  const { hce, dataAfiliado, disabled } = props;

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} lg={6}>
          <Paper className={fixedHeightPaper}>
            <CardVacunas dataAfiliado={dataAfiliado} hce={hce}/>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          <Paper className={fixedHeightPaper}>
            <CardSignosVitales hce={hce} dataAfiliado={dataAfiliado} disabled={disabled}/>
          </Paper>
        </Grid>

      </Grid>
    </React.Fragment>
  )
}
